import Vue from "vue";
import VueI18n from "vue-i18n";
import { SITE_LANGUAGE, LANG_EN, TRANSLATIONS_READY } from "@/common/consts";
import { expandDictionary } from "@/common/functions";

Vue.use(VueI18n);

const defaultLang = SITE_LANGUAGE;
const fallbackLang = LANG_EN;

const i18n = new VueI18n({
	locale: defaultLang,
	fallbackLocale: fallbackLang,
	messages: {},
	silentTranslationWarn: true,
});
// Signals that localization strings are available
const dispatchTranslationsEvent = () => {
	document.dispatchEvent(new CustomEvent(TRANSLATIONS_READY));
};
const loadLanguage = (lang) => {
	return import(
		/* webpackChunkName: "lang-[request]" */ `./translations/${lang}.js`
	).then((messages) => {
		i18n.mergeLocaleMessage(lang, expandDictionary(messages.default));
		if (window.__PRERENDER_INJECTED) {
			setTimeout(function() {
				dispatchTranslationsEvent();
			}, 100);
		} else {
			dispatchTranslationsEvent();
		}
	});
};

loadLanguage(SITE_LANGUAGE);

export default i18n;
